import React from 'react';
import ModelSelection from '../ModelSelection';
import { NavLink } from "react-router-dom";

class Navigation extends React.Component {
  setNavLinkClass(phase, index) {
    let classString = "";
    if(index === 0) {
      classString = "first";
    } else
    if(index === this.props.state.phases.length - 1) {
      classString = "last";
    } else {
      classString = "middle";
    }
    if(this.props.state.phase > phase.id) {
      classString += " phase-done";
    } else {
      if((phase.name !== "Toteutustapa" && (!this.props.state.implementationModel || this.props.state.implementationModel === "null")) ||
         (phase.name !== "Toteutustapa" && phase.name !== "Rahoitusmalli" && !this.props.state.selectedFundings.length)) {
        classString += " phase-inactive";
      }
    }
    return classString;
  }

  render() {
    return (
      <div className="navigation-wrapper">
        <div className="navigation">
          <div className="navigation-inner">
            {this.props.state.phases.map((phase, index) =>
              <NavLink key={phase.id} className={this.setNavLinkClass(phase, index)} to={phase.path} exact>{phase.name}</NavLink>
            )}
          </div>
        </div>
        {
          this.props.state.implementationModel &&
          (this.props.state.phase === 2 ||
          this.props.state.phase === 3) ?
            <ModelSelection
              path={this.props.state.phases[0].path}
              phase={this.props.state.phases[0].id}
              label="Toteutustapa"
              models={this.props.state.implementationModels.filter(model => model.slug === this.props.state.implementationModel)}
              updateState={this.props.updateState} /> : null
        }
        {
          this.props.state.selectedFundings.length && this.props.state.phase === 3 ?
            <ModelSelection
              path={this.props.state.phases[1].path}
              phase={this.props.state.phases[1].id}
              label={this.props.state.selectedFundings.length > 1 ? "Rahoitusmallit" : "Rahoitusmalli"}
              models={this.props.state.fundingModels.filter(model => this.props.state.selectedFundings.includes(model.slug)).reverse()}
              updateState={this.props.updateState} /> : null
        }
      </div>
    );
  }
}

export default Navigation;
